module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Other Books from Bright Leaf")]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('i', [_vm._v("House Stories:")]), _vm._v(" "), _c('i', [_vm._v("The Meanings of Home in a New England Town")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("BETH LUEY")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Bricklayer Bill:")]), _vm._v(" "), _c('i', [_vm._v("The Untold Story of the Workingman’s Boston Marathon")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("PATRICK L. KENNEDY AND LAWRENCE W. KENNEDY")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Concrete Changes:")]), _vm._v(" "), _c('i', [_vm._v("Architecture, Politics, and the Design of Boston City Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("BRIAN M. SIRMAN")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Williamstown and Williams College:")]), _vm._v(" "), _c('i', [_vm._v("Explorations in Local History")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("DUSTIN GRIFFIN")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Massachusetts Treasures")]), _vm._v(": "), _c('i', [_vm._v("A Guide to Marvelous, Must-See Museums")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("CHUCK D’IMPERIO")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Boston’s Twentieth-Century Bicycling Renaissance")]), _vm._v(": "), _c('i', [_vm._v("Cultural Change on Two Wheels")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("LORENZ J. FINISON")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Went to the Devil")]), _vm._v(": "), _c('i', [_vm._v("A Yankee Whaler in the Slave Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("ANTHONY J. CONNORS")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("At Home")]), _vm._v(": "), _c('i', [_vm._v("Historic Houses of Eastern Massachusetts")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("BETH LUEY")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Black Lives, Native Lands, White Worlds")]), _vm._v(": "), _c('i', [_vm._v("A History of Slavery in New England")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("JARED ROSS HARDESTY")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("At Home")]), _vm._v(": "), _c('i', [_vm._v("Historic Houses of Central and Western Massachusetts")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("BETH LUEY")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Flight Calls")]), _vm._v(": "), _c('i', [_vm._v("Exploring Massachusetts through Birds")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("JOHN R. NELSON")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Lost Wonderland")]), _vm._v(": "), _c('i', [_vm._v("The Brief and Brilliant Life of Boston’s Million Dollar Amusement Park")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("STEPHEN R. WILK")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_vm._v("I Believe I’ll Go Back Home: Roots and Revival in New England Folk Music")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("THOMAS S. CURREN")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_vm._v("Legends of the Common Stream")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("JOHN HANSON MITCHELL")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_vm._v("Mind and Hearts: The Story of James Otis Jr. and Mercy Otis Warren")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Jeffrey H. Hacker")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("The Combat Zone")]), _vm._v(": "), _c('i', [_vm._v("Murder, Race, and Boston’s Struggle for Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("JAN BROGAN")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Letters from Red Farm")]), _vm._v(": "), _c('i', [_vm._v("The Untold Story of the Friendship between Helen Keller and Journalist Joseph Edgar Chamberlin")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("ELIZABETH EMERSON")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ec3afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma_Bane0003.vue
// module id = 60
// module chunks = 0